import axios from 'axios';
import authHeader from './auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/charts/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/charts/';

class ChartsService {
  getTeamStats(teamId) {
    return axios.get(API_URL  + "team/" + teamId);
  }

  getRequestedReports(clientId,petition) {
    return axios.get(API_URL  + "player-reports/client/" + clientId + "/petition/" + petition);
  }

  getAllClientsScoutedPlayers() {
    return axios.get(API_URL  + "player-reports/scouted");
  }

  getAllClientsRequestedReports() {
    return axios.get(API_URL  + "player-reports");
  }

  getTeamBarChartData(seasonId, teamId) {
    return axios.get(API_URL  + "stacked-bar-chart/season/" + seasonId + "/team/" + teamId);
  }

  getTeamBarChartDataByGames(gameIds, teamId) {
    return axios.get(API_URL  + "stacked-bar-chart/games/" + gameIds + "/team/" + teamId);
  }

  getLeagueBarChartData(seasonId) {
    return axios.get(API_URL  + "stacked-bar-chart/season/" + seasonId );
  }

  getLeaguePhysicalStatsData(seasonId) {
    return axios.get(API_URL  + "pd-stats/season/" + seasonId );
  }

  getXTGame(gameId) {
    return axios.get(API_URL  + "xT/game/" + gameId, { headers: authHeader() });
  }
}

export default new ChartsService();
